export const flattenClassificationsData = (data) => {
    const flatData = [];

    const flattenRecursively = (item) => {
        flatData.push(item);

        if (item.children && item.children.length > 0) {
            item.children.forEach((child) => flattenRecursively(child));
        }
    };
    data.forEach((item) => flattenRecursively(item));
    return flatData;
};
